import {phone} from './VuelidateCustomValidatoins'
import {gregorian_to_jalali, jalali_to_gregorian} from './jalali'
import {i18n} from "@/main";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";


export const pad = (num, size) => {
    let s = num + ''
    while (s.length < size) s = '0' + s
    return s
}

export const changeFormShapeIfItIsPhone = (form) => {
    if (phone(form.email)) {
        form = {...form, cellphone: form.email}
        delete form.email
        return form
    }
    return form
};
export const checkDuplicate = (items, newItem) => {
    return items.indexOf(newItem);
}

export const convertToJalali = (date, separator = '/') => {
    let convertToDateObject = new Date(date)
    return gregorian_to_jalali(convertToDateObject.getFullYear(), convertToDateObject.getMonth() + 1, convertToDateObject.getDate()).join(separator)
};

export const convertToGregory = (date, separator = '/') => {
    let convertToDateObject = new Date(date)
    return jalali_to_gregorian(convertToDateObject.getFullYear(), convertToDateObject.getMonth() + 1, convertToDateObject.getDate()).join(separator)
};

export const convertToGregoryWithTime = (date, separator = '-') => {
    let convertToDateObject = new Date(date)
    return jalali_to_gregorian(convertToDateObject.getFullYear(), convertToDateObject.getMonth() + 1, convertToDateObject.getDate()).join(separator) + ' ' + pad(convertToDateObject.getHours(), 2) + ':' + pad(convertToDateObject.getMinutes(), 2) + ':' + pad(convertToDateObject.getSeconds(), 2)
};

export const convertToJalaliWithTime = (date, separator = '-') => {
    let convertToDateObject = new Date(date)
    return gregorian_to_jalali(convertToDateObject.getFullYear(), convertToDateObject.getMonth() + 1, convertToDateObject.getDate()).join(separator) + ' ' + pad(convertToDateObject.getHours(), 2) + ':' + pad(convertToDateObject.getMinutes(), 2) + ':' + pad(convertToDateObject.getSeconds(), 2)
};


export const gregoryFormat = (date, separator = '/') => {
    let convertToDateObject = new Date(date)
    return [pad(convertToDateObject.getFullYear(), 2), pad(convertToDateObject.getMonth() + 1, 2), pad(convertToDateObject.getDate(), 2)].join(separator)
};

export const gregoryFormatWithTime = (date, separator = '-') => {
    let convertToDateObject = new Date(date)
    return [pad(convertToDateObject.getFullYear(), 2), pad(convertToDateObject.getMonth() + 1, 2), pad(convertToDateObject.getDate(), 2)].join(separator) + ' ' + pad(convertToDateObject.getHours(), 2) + ':' + pad(convertToDateObject.getMinutes(), 2) + ':' + pad(convertToDateObject.getSeconds(), 2)
};


export const dateConverter = (date, separator = '/', time = false, to = 'jalali') => {
    // for support weekname, show year with only two digit or show time with different format use: toLocaleTimeString and toLocaleDateString
    // the only issue they have is: you can't set order for them example: show year first or show month and then year
    to = i18n.global != undefined ? i18n.global.messages[i18n.global.locale]['date']['date_format'] : to
    if (to === 'jalali') {
        if (time) {
            return convertToJalaliWithTime(date, separator)
        }
        return convertToJalali(date, separator)
    }
    if (to === 'gregory') {
        if (time) {
            return gregoryFormatWithTime(date, separator)
        }
        return gregoryFormat(date, separator)
    }
    return date
}

export const removeBlankAttributes = (data) => {
    return Object.fromEntries(Object.entries(data).filter(([_, v]) => v !== ""))
}

export const findObjects = (items, item) => {
    let result = null
    items.filter(i => {
        if (i.name === item) {
            result = i
        }
    })
    return result

}

export const findObjectIndex = (items, item) => {
    let result = null
    items.filter((i, index) => {
        if (i.id === item.id) {
            result = index
        }
    })
    return result
}

export const formatNumber = (Number) => {
    const formatter = i18n.global != undefined ? i18n.global.messages[i18n.global.locale]['price']['price_format'] : 'fa-IR'
    if (Number == undefined) {
        return 0
    }
    return parseInt(Number).toLocaleString(formatter)
}

export const walletValue = (wallet) => {
    if (wallet == null) {
        return 0
    }
    return wallet.value
}

export const traverseAndFlatten = (currentNode, target, flattenedKey) => {
    for (var key in currentNode) {
        if (currentNode.hasOwnProperty(key)) {
            var newKey;
            if (flattenedKey === undefined) {
                newKey = key;
            } else {
                newKey = flattenedKey + '.' + key;
            }

            var value = currentNode[key];
            if (typeof value === "object") {
                traverseAndFlatten(value, target, newKey);
            } else {
                target[newKey] = value;
            }
        }
    }
}

export const flatten = (obj) => {
    var flattenedObject = {};
    traverseAndFlatten(obj, flattenedObject);
    return flattenedObject;
}

export const getBaseDomain = (https = true) => {
    let domain = findAttributeOnSiteInfo('site_link')[0]
    return https ? domain : domain.replace('https://', '');
}

export const generateRandomString = () => {
    return (
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15)
    );
}